// extracted by mini-css-extract-plugin
module.exports = {"OASIS-D":"OASIS3_OASIS-D__2auK6"};